/**
 * useCaptureEscape
 *
 * Registriert einen Escape-Handler in der **Capture-Phase**, damit ein modaler Dialog/Launcher beim
 * Schließen den bubble-phase Escape-Handler der `ScoreEditToolbar` (Auswahl aufheben) NICHT parallel
 * feuern lässt (`stopImmediatePropagation`). Der `document`-Listener ist **nur aktiv, solange `active`
 * true ist** – geschlossene Overlays hängen also keinen globalen Per-Tastendruck-Listener ein.
 *
 * Geteilt von `NoteGripDialog`/`NoteActionsOverlay` (Muster analog `KeyboardShortcutsDialog.vue`).
 */
import {type MaybeRefOrGetter, onScopeDispose, toValue, watch} from 'vue';

export function useCaptureEscape(active: MaybeRefOrGetter<boolean>, onEscape: () => void): void {
    function handler(e: KeyboardEvent): void {
        if (e.key !== 'Escape') return;
        e.preventDefault();
        e.stopImmediatePropagation();
        onEscape();
    }

    function remove(): void {
        document.removeEventListener('keydown', handler, {capture: true});
    }

    watch(
        () => toValue(active),
        (on) => (on ? document.addEventListener('keydown', handler, {capture: true}) : remove()),
        {immediate: true},
    );

    onScopeDispose(remove);
}
